import { externalLaunchContextAtom } from '@heidi/integrations/ehr/data/atoms';
import { useAtomValue } from 'jotai';
import {
  isSmartOnFhirLaunch,
  resolveHiddenNavInSmartOnFhirLaunch,
  type SmartOnFhirHiddenNavItem,
} from './smartOnFhirLaunchNav';

/**
 * Whether the app is running inside a generic SMART App Launch. Narrower than
 * `useIsEhrLaunch`: see `isSmartOnFhirLaunch` for which launches qualify.
 */
export const useIsSmartOnFhirLaunch = (): boolean =>
  isSmartOnFhirLaunch(useAtomValue(externalLaunchContextAtom));

/**
 * The primary-nav entry points to hide for the current launch. Empty outside
 * a generic SMART launch, so callers can gate with `.has(...)` unconditionally.
 */
export const useHiddenNavInSmartOnFhirLaunch =
  (): ReadonlySet<SmartOnFhirHiddenNavItem> =>
    resolveHiddenNavInSmartOnFhirLaunch(useAtomValue(externalLaunchContextAtom));
